<template>
	<section :class="{'outer-pad': true, 'page-info': true, canEdit: !readOnly}" v-if="loaded">
		<h2 class="page-name" id="project-name">
			<span :class="{ name: true, editing: editingName }"
				><span>{{ projectName }}</span
				><FormInput
					type="text"
					@aKeyup="updateName"
					:noMarginBottom="true"
					:focus="true"
					v-model="projectName"
					v-if="editingName"
					style="display:inline-block"
					class="form-input"
			/></span>

			<span class="edit" v-if="!readOnly">
				<font-awesome-icon
					class="edit"
					icon="floppy-disk"
					:style="{ color: '#3b445b' }"
					v-if="editingName"
					@click="updateName('save')"
				/>
				<font-awesome-icon
					class="edit"
					icon="pencil-alt"
					:style="{ color: '#3b445b' }"
					v-if="!editingName"
					@click="editingName = !editingName"
				/>
			</span>
		</h2>

		<ProjectFeatures
			:project="project"
			:ignore="ignoreFeatures"
			:show="showFeatures"
		/>

		<slot name="right" />
	</section>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import ApiService from "./../../services/api.service";
import ProjectFeatures from "./ProjectFeatures.vue";
import FormInput from "./../Form/Input.vue";
export default {
	name: "ProjectTitle",
	props: {
		project: {
			type: Object,
			default: () => {}
		},
		ignoreFeatures: {
			type: Array,
			default: () => []
		},
		showFeatures: {
			type: Array,
			default: () => []
		},
		readOnly: {
			type: Boolean,
			default: false
		},
		dataDive: {
			type: Boolean,
			default: false
		}
	},
	components: { ProjectFeatures, FormInput },
	data() {
		return {
			editingName: false,
			updatingName: false,
			projectName: "",
			loaded: false
		};
	},
	watch: {
		project: {
			handler() {
				this.projectName = this.project.name;
				if ( this.dataDive && !!this.project.url ) {
					this.projectName = this.project.url.replaceAll('https://','').replaceAll('/','');
				}
				if (!!this.projectName) this.loaded = true;
			},
			immediate: true
		}
	},
	methods: {
		...mapActions("general", ["loadProjects"]),

		updateName(type) {
			if (!this.projectName) return;

			const theType = typeof type === "string" ? type : type.key;

			if (this.updatingName) return;

			if (["Escape", "save"].indexOf(theType) >= 0) {
				this.editingName = false;
				return;
			}

			this.updatingName = true;

			ApiService.put(
				"projects/" + this.$route.params.projectId + "/update-name",
				{ name: this.projectName }
			)
				.then(
					function(info) {
						this.updatingName = false;

						this.loadProjects({ projectListLoaded: true, force: true });
					}.bind(this)
				)
				.catch(
					function(err) {
						this.updatingName = false;
					}.bind(this)
				);
		}
	},
	computed: {}
};
</script>
<style lang="less" scoped>
@import "./../../assets/css/less/_helper.less";
@import "./../../assets/css/less/_settings.less";
@import "./../../assets/css/less/components/_page-info.less";
.page-info {
	.page-name {
		display: inline-block;
		vertical-align: top;
		padding: 0;
		position: relative;
		.name {
			font-size: 24px;
			color: @darkContrast;
			position: relative;
			display: inline-block;
			&.editing {
				span {
					opacity: 0;
					min-width: 100px;
    				min-height: 1.3em;
					display: block;
				}
			}
			.form-input {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				min-width: 100px;
			}
		}
		> .edit {
			width: 20px;
			height: 20px;
			display: inline-block;
			position: absolute;
			z-index: 2;
			right: 3px;
			top: 5px;
			svg {
				width: 100%;
				cursor: pointer;
				opacity: 0.7;
				display: block;
				&.save {
					vertical-align: middle;
				}
				&:hover {
					opacity: 1;
				}
			}
		}
	}
	&.canEdit {
		position: relative;
		.page-name {
			padding-right: 32px;
		}
	}
}
@media screen and (min-width: 768px) {
	.page-info {
		.page-name {
			margin-right: 20px;
		}
	}
}
</style>
